module.exports = __webpack_public_path__ + "img/img_lqzx.05e0315e.png";